module.exports = __webpack_public_path__ + "img/b.e8e3e07d.jpg";